import { toFixed } from '../../../core/services/utils/numbers';

/** Calcula o percentual da quantidade realizada sobre a quantidade pretendida/projetada */
export function calcularQuantidadeRealizadaPerc(quantidadeRealizada: number, quantidadePretendidaProjetada: number): number {
    quantidadeRealizada = quantidadeRealizada && !isNaN(quantidadeRealizada) ? Number(quantidadeRealizada) : 0;
    quantidadePretendidaProjetada = quantidadePretendidaProjetada && !isNaN(quantidadePretendidaProjetada) ? Number(quantidadePretendidaProjetada) : 0;

    if (quantidadePretendidaProjetada === 0) {
        return 0;
    }

    const perc = (quantidadeRealizada / quantidadePretendidaProjetada) * 100;
    return toFixed(perc, 2);
}

/** Calcula o percentual do peso realizado sobre peso pretendido/projetado */
export function calcularPesoRealizadoPerc(pesoRealizado: number, pesoPretendidoProjetado: number): number {
    pesoRealizado = pesoRealizado && !isNaN(pesoRealizado) ? Number(pesoRealizado) : 0;
    pesoPretendidoProjetado = pesoPretendidoProjetado && !isNaN(pesoPretendidoProjetado) ? Number(pesoPretendidoProjetado) : 0;

    if (pesoPretendidoProjetado === 0) {
        return 0;
    }

    const perc = (pesoRealizado / pesoPretendidoProjetado) * 100;
    return toFixed(perc, 2);
}


/** Calcula o percentual do valor realizado sobre o valor pretendido/projetado */
export function calcularValorRealizadoPerc(valorRealizado: number, valorPretendidoProjetado: number): number {
    valorRealizado = valorRealizado && !isNaN(valorRealizado) ? Number(valorRealizado) : 0;
    valorPretendidoProjetado = valorPretendidoProjetado && !isNaN(valorPretendidoProjetado) ? Number(valorPretendidoProjetado) : 0;

    if (valorPretendidoProjetado === 0) {
        return 0;
    }

    const perc = (valorRealizado / valorPretendidoProjetado) * 100;
    return toFixed(perc, 2);
}
